






















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import { SituacaoEnum } from '@/types/_'

@Component
export default class ComponentBackofficeGerarCobrancaInformarPagamento extends Vue {
  $refs!: {
    gerarCobrancaInformarPagamentoForm: any,
  }

  metodosDePagamento = [
    { text: 'Pix', value: 'Pix' },
    { text: 'Boleto', value: 'Boleto' },
    { text: 'Débito', value: 'Debito' },
    { text: 'Cartão de crédito', value: 'CartaoDeCredito' },
    { text: 'Financiamento', value: 'Financiamento' },
  ]

  gerarCobrancaInformarPagamentoFormRules = {
    valid: true,
    pagamentoId: [(v: any) => !!v || 'Campo obrigatório.'],
    valor: [(v: any) => this.validateValor(v)],
    metodoPagamento: [(v: any) => !!v || 'Campo obrigatório.'],
    dataPagamento: [(v: any) => this.validateDataPagamento(v)],
  }

  validateValor(v: any) {
    if (!v) return 'Campo obrigatório.'
    return Number(v.replace(',', '.')) <= 0 ? 'Campo obrigatório.' : false
  }

  validateDataPagamento(v: any) {
    if (this.getBackofficeGlobalStore.solicitacao.situacao.key !== SituacaoEnum.AguardandoPagamento) return false
    if (!v) return 'Campo obrigatório.'
    return false
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get geracaoDaCobranca() {
    return this.getBackofficeGlobalStore.solicitacao.etapa.key === 'Orcamento'
      && this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AguardandoGeracaoDaCobranca
  }

  get aguardandoPagamento() {
    return this.getBackofficeGlobalStore.solicitacao.etapa.key === 'Orcamento'
      && this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AguardandoPagamento
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }
}
